/**
 * Literales de UI globales del admin (botones y verbos repetidos en todas las
 * vistas). Los fragmentos por vista NO deben re-declarar estos.
 */

export const DICCIONARIO_COMUNES = {
    'Nuevo producto': { pt: 'Novo produto', en: 'New product', ru: 'Новый продукт' },
    Guardar: { pt: 'Salvar', en: 'Save', ru: 'Сохранить' },
    Cancelar: { pt: 'Cancelar', en: 'Cancel', ru: 'Отмена' },
    Editar: { pt: 'Editar', en: 'Edit', ru: 'Изменить' },
    Duplicar: { pt: 'Duplicar', en: 'Duplicate', ru: 'Дублировать' },
    Eliminar: { pt: 'Excluir', en: 'Delete', ru: 'Удалить' },
    'Exportar a Excel': { pt: 'Exportar para Excel', en: 'Export to Excel', ru: 'Экспорт в Excel' },
    'Exportar a PDF': { pt: 'Exportar para PDF', en: 'Export to PDF', ru: 'Экспорт в PDF' },
    // Patrón canónico de listados (agrupar / KPIs / cierre)
    Agrupar: { pt: 'Agrupar', en: 'Group by', ru: 'Группировать' },
    grupos: { pt: 'grupos', en: 'groups', ru: 'групп' },
    registros: { pt: 'registros', en: 'records', ru: 'записей' },
    'Cierre del período': { pt: 'Fechamento do período', en: 'Period settlement', ru: 'Итог периода' },
    'Ver el detalle de este grupo': { pt: 'Ver o detalhe deste grupo', en: 'View this group detail', ru: 'Открыть детали группы' },
    'Monedas mixtas: consolidar en el backend': { pt: 'Moedas mistas: consolidar no backend', en: 'Mixed currencies: consolidate in backend', ru: 'Разные валюты: консолидация на сервере' },
    Renombrar: { pt: 'Renomear', en: 'Rename', ru: 'Переименовать' },
    Crear: { pt: 'Criar', en: 'Create', ru: 'Создать' },
    'Sí': { pt: 'Sim', en: 'Yes', ru: 'Да' },
    'No': { pt: 'Não', en: 'No', ru: 'Нет' },
    Pendiente: { pt: 'Pendente', en: 'Pending', ru: 'В ожидании' },
    Fallido: { pt: 'Falhou', en: 'Failed', ru: 'Ошибка' },
    Cerrar: { pt: 'Fechar', en: 'Close', ru: 'Закрыть' },
    Buscar: { pt: 'Buscar', en: 'Search', ru: 'Поиск' },
    Activo: { pt: 'Ativo', en: 'Active', ru: 'Активен' },
    Inactivo: { pt: 'Inativo', en: 'Inactive', ru: 'Неактивен' },
    Idioma: { pt: 'Idioma', en: 'Language', ru: 'Язык' },
    // Menú lateral + topbar (index.html, vía [data-i18n])
    Dashboard: { pt: 'Painel', en: 'Dashboard', ru: 'Панель' },
    Juegos: { pt: 'Jogos', en: 'Games', ru: 'Игры' },
    Plataforma: { pt: 'Plataforma', en: 'Platform', ru: 'Платформа' },
    Clientes: { pt: 'Clientes', en: 'Customers', ru: 'Клиенты' },
    Actividad: { pt: 'Atividade', en: 'Activity', ru: 'Активность' },
    Finanzas: { pt: 'Finanças', en: 'Finance', ru: 'Финансы' },
    Marketing: { pt: 'Marketing', en: 'Marketing', ru: 'Маркетинг' },
    Auditoría: { pt: 'Auditoria', en: 'Audit', ru: 'Аудит' },
    'Sistema Online': { pt: 'Sistema Online', en: 'System Online', ru: 'Система онлайн' },
    // Consolidados desde diccionarios específicos (estaban repetidos en 3+ archivos).
    'Operación': { pt: 'Operação', en: 'Operation', ru: 'Операция' },
    'Punto de Venta': { pt: 'Ponto de Venda', en: 'Point of Sale', ru: 'Точка продаж' },
    Tickets: { pt: 'Tickets', en: 'Tickets', ru: 'Билеты' },
    Sistema: { pt: 'Sistema', en: 'System', ru: 'Система' },
    'Error al guardar': { pt: 'Erro ao salvar', en: 'Error saving', ru: 'Ошибка при сохранении' },
    'Error al eliminar': { pt: 'Erro ao excluir', en: 'Error deleting', ru: 'Ошибка при удалении' },
    Contrato: { pt: 'Contrato', en: 'Contract', ru: 'Контракт' },
    Creado: { pt: 'Criado', en: 'Created', ru: 'Создан' },
    Bonus: { pt: 'Bônus', en: 'Bonus', ru: 'Бонус' },
    Cliente: { pt: 'Cliente', en: 'Customer', ru: 'Клиент' },
    Nodo: { pt: 'Nó', en: 'Node', ru: 'Узел' },
    Dispositivo: { pt: 'Dispositivo', en: 'Device', ru: 'Устройство' },
    Monto: { pt: 'Valor', en: 'Amount', ru: 'Сумма' },
    'Cargando...': { pt: 'Carregando...', en: 'Loading...', ru: 'Загрузка...' },
    Nombre: { pt: 'Nome', en: 'Name', ru: 'Имя' },
    Rango: { pt: 'Faixa', en: 'Range', ru: 'Диапазон' },
    Sorteos: { pt: 'Sorteios', en: 'Draws', ru: 'Розыгрыши' },
    Acciones: { pt: 'Ações', en: 'Actions', ru: 'Действия' },
    Default: { pt: 'Padrão', en: 'Default', ru: 'По умолчанию' },
    Borrar: { pt: 'Excluir', en: 'Delete', ru: 'Удалить' },
    'Notas (opcional)': { pt: 'Notas (opcional)', en: 'Notes (optional)', ru: 'Примечания (необязательно)' },
    Heredar: { pt: 'Herdar', en: 'Inherit', ru: 'Наследовать' },
    Cuenta: { pt: 'Conta', en: 'Account', ru: 'Счёт' },
    Activar: { pt: 'Ativar', en: 'Activate', ru: 'Активировать' },
    Alcance: { pt: 'Alcance', en: 'Scope', ru: 'Область' },
    'Sin resultados': { pt: 'Sem resultados', en: 'No results', ru: 'Нет результатов' },
    'Esta accion no se puede deshacer.': { pt: 'Esta ação não pode ser desfeita.', en: 'This action cannot be undone.', ru: 'Это действие нельзя отменить.' },
    Estado: { pt: 'Status', en: 'Status', ru: 'Статус' },
    Fecha: { pt: 'Data', en: 'Date', ru: 'Дата' },
    Cerrado: { pt: 'Fechado', en: 'Closed', ru: 'Закрыто' },
    Tipo: { pt: 'Tipo', en: 'Type', ru: 'Тип' },
    Todos: { pt: 'Todos', en: 'All', ru: 'Все' },
    'Seleccionar...': { pt: 'Selecionar...', en: 'Select...', ru: 'Выбрать...' },
    Operador: { pt: 'Operador', en: 'Operator', ru: 'Оператор' },
    Representante: { pt: 'Representante', en: 'Representative', ru: 'Представитель' },
    Caja: { pt: 'Caixa', en: 'Till', ru: 'Касса' },
    VLT: { pt: 'VLT', en: 'VLT', ru: 'VLT' },
    personalizado: { pt: 'personalizado', en: 'custom', ru: 'настраиваемый' },
    Confirmar: { pt: 'Confirmar', en: 'Confirm', ru: 'Подтвердить' },
    Vigente: { pt: 'Vigente', en: 'Current', ru: 'Действующий' },
    Serial: { pt: 'Serial', en: 'Serial', ru: 'Серийный номер' },
    // Consolidados (2ª pasada): claves que vivían en 2 diccionarios.
    'Ver ficha': { pt: 'Ver ficha', en: 'View details', ru: 'Открыть карточку' },
    'Seleccionar caja...': { pt: 'Selecionar caixa...', en: 'Select till...', ru: 'Выбрать кассу...' },
    Vistas: { pt: 'Telas', en: 'Views', ru: 'Представления' },
    Nodos: { pt: 'Nós', en: 'Nodes', ru: 'Узлы' },
    Dispositivos: { pt: 'Dispositivos', en: 'Devices', ru: 'Устройства' },
    'Las contraseñas no coinciden': { pt: 'As senhas não coincidem', en: 'Passwords do not match', ru: 'Пароли не совпадают' },
    'Nuevo punto de venta': { pt: 'Novo Ponto de Venda', en: 'New point of sale', ru: 'Новая точка продаж' },
    'Nodo creado': { pt: 'Nó criado', en: 'Node created', ru: 'Узел создан' },
    'Nodo movido': { pt: 'Nó movido', en: 'Node moved', ru: 'Узел перемещён' },
    'Adelanto rechazado': { pt: 'Adiantamento rejeitado', en: 'Advance rejected', ru: 'Аванс отклонён' },
    Ajuste: { pt: 'Ajuste', en: 'Adjustment', ru: 'Корректировка' },
    Creditos: { pt: 'Créditos', en: 'Credits', ru: 'Кредиты' },
    Influencer: { pt: 'Influencer', en: 'Influencer', ru: 'Инфлюэнсер' },
    'Acción': { pt: 'Ação', en: 'Action', ru: 'Действие' },
    'Liquidación': { pt: 'Liquidação', en: 'Settlement', ru: 'Расчёт' },
    Metodo: { pt: 'Método', en: 'Method', ru: 'Метод' },
    Inicio: { pt: 'Início', en: 'Start', ru: 'Начало' },
    'Ultima actividad': { pt: 'Última atividade', en: 'Last activity', ru: 'Последняя активность' },
    Apuestas: { pt: 'Apostas', en: 'Bets', ru: 'Ставки' },
    Duracion: { pt: 'Duração', en: 'Duration', ru: 'Продолжительность' },
    ID: { pt: 'ID', en: 'ID', ru: 'ID' },
    Activa: { pt: 'Ativa', en: 'Active', ru: 'Активна' },
    Inactiva: { pt: 'Inativa', en: 'Inactive', ru: 'Неактивна' },
    'Nombre es requerido': { pt: 'Nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    Generar: { pt: 'Gerar', en: 'Generate', ru: 'Сгенерировать' },
    'Error guardando configuración': { pt: 'Erro ao salvar configuração', en: 'Error saving configuration', ru: 'Ошибка при сохранении настроек' },
    Cuarteto: { pt: 'Quarteto', en: 'Quartet', ru: 'Квартет' },
    Gemelos: { pt: 'Gêmeos', en: 'Twins', ru: 'Близнецы' },
    'Partners externos': { pt: 'Parceiros externos', en: 'External partners', ru: 'Внешние партнёры' },
    Adelantos: { pt: 'Adiantamentos', en: 'Advances', ru: 'Авансы' },
    Conformidad: { pt: 'Conformidade', en: 'Compliance', ru: 'Соответствие' },
    Notas: { pt: 'Notas', en: 'Notes', ru: 'Примечания' },
    Obligaciones: { pt: 'Obrigações', en: 'Obligations', ru: 'Обязательства' },
    Otro: { pt: 'Outro', en: 'Other', ru: 'Другое' },
    'Plazo:': { pt: 'Prazo:', en: 'Deadline:', ru: 'Срок:' },
    Siguiente: { pt: 'Próximo', en: 'Next', ru: 'Далее' },
    'Sin limite': { pt: 'Sem limite', en: 'No limit', ru: 'Без ограничения' },
    Retiros: { pt: 'Saques', en: 'Withdrawals', ru: 'Выводы' },
    // 'Apostado' unificado a 'Jugado' (Dominio 1, SPEC nomenclatura) — ver clave Jugado más abajo.
    'Copiado al portapapeles': { pt: 'Copiado para a área de transferência', en: 'Copied to clipboard', ru: 'Скопировано в буфер обмена' },
    'Todos los juegos': { pt: 'Todos os jogos', en: 'All games', ru: 'Все игры' },
    Tiempo: { pt: 'Tempo', en: 'Time', ru: 'Время' },
    'Sorteo #': { pt: 'Sorteio #', en: 'Draw #', ru: 'Розыгрыш №' },
    Intervalo: { pt: 'Intervalo', en: 'Interval', ru: 'Интервал' },
    ACTIVO: { pt: 'ATIVO', en: 'ACTIVE', ru: 'АКТИВЕН' },
    PAUSADO: { pt: 'PAUSADO', en: 'PAUSED', ru: 'ПРИОСТАНОВЛЕН' },
    'Sin cambios en': { pt: 'Sem alterações em', en: 'No changes in', ru: 'Без изменений в' },
    'Cambios en': { pt: 'Alterações em', en: 'Changes in', ru: 'Изменения в' },
    'Sin imagen': { pt: 'Sem imagem', en: 'No image', ru: 'Нет изображения' },
    Codigo: { pt: 'Código', en: 'Code', ru: 'Код' },
    Telefono: { pt: 'Telefone', en: 'Phone', ru: 'Телефон' },
    Total: { pt: 'Total', en: 'Total', ru: 'Итого' },
    Registro: { pt: 'Cadastro', en: 'Registration', ru: 'Регистрация' },
    Jugado: { pt: 'Jogado', en: 'Wagered', ru: 'Сыграно' },
    'Dinero jugado': { pt: 'Dinheiro jogado', en: 'Wagered with money', ru: 'Сыграно деньгами' },
    Rejuego: { pt: 'Rejogo', en: 'Replayed', ru: 'Переиграно' },
    Desactivar: { pt: 'Desativar', en: 'Deactivate', ru: 'Деактивировать' },
    Contraer: { pt: 'Recolher', en: 'Collapse', ru: 'Свернуть' },
    Expandir: { pt: 'Expandir', en: 'Expand', ru: 'Развернуть' },
    Global: { pt: 'Global', en: 'Global', ru: 'Глобальный' },
    'Buscando...': { pt: 'Buscando...', en: 'Searching...', ru: 'Поиск...' },
    'Nueva Promocion': { pt: 'Nova Promoção', en: 'New Promotion', ru: 'Новая акция' },
    'Opciones avanzadas': { pt: 'Opções avançadas', en: 'Advanced options', ru: 'Расширенные настройки' },
    'Global (todo el brand)': { pt: 'Global (toda a marca)', en: 'Global (entire brand)', ru: 'Глобально (весь бренд)' },
    'Buscar...': { pt: 'Buscar...', en: 'Search...', ru: 'Поиск...' },
    Modo: { pt: 'Modo', en: 'Mode', ru: 'Режим' },
    activada: { pt: 'ativada', en: 'enabled', ru: 'включена' },
    'Pre-impreso': { pt: 'Pré-impresso', en: 'Pre-printed', ru: 'Предварительно напечатано' },
    'QR mostrador': { pt: 'QR balcão', en: 'Counter QR', ru: 'QR на стойке' },
    'Comisión': { pt: 'Comissão', en: 'Commission', ru: 'Комиссия' },
    'Recargas Wallet': { pt: 'Recargas Wallet', en: 'Wallet Top-ups', ru: 'Пополнения кошелька' },
    'Venta de Tickets': { pt: 'Venda de Tickets', en: 'Ticket Sales', ru: 'Продажа билетов' },
    'Cerrar Corte': { pt: 'Fechar Caixa', en: 'Close Cash-up', ru: 'Закрыть смену' },
    'Nuevo Pozo Común': { pt: 'Novo Poço Comum', en: 'New Shared Pool', ru: 'Новый общий пул' },
    'Primer apostador': { pt: 'Primeiro apostador', en: 'First bettor', ru: 'Первый игрок' },
    'Último apostador': { pt: 'Último apostador', en: 'Last bettor', ru: 'Последний игрок' },
    Cajero: { pt: 'Operador de Caixa', en: 'Cashier', ru: 'Кассир' },
    Permisos: { pt: 'Permissões', en: 'Permissions', ru: 'Права доступа' },
    Email: { pt: 'E-mail', en: 'Email', ru: 'Эл. почта' },
    'Autorizar Dispositivo': { pt: 'Autorizar Dispositivo', en: 'Authorize Device', ru: 'Авторизовать устройство' },
    Autorizar: { pt: 'Autorizar', en: 'Authorize', ru: 'Авторизовать' },
    Vigencia: { pt: 'Vigência', en: 'Validity', ru: 'Срок действия' },
    'Registrar Pago': { pt: 'Registrar Pagamento', en: 'Register Payment', ru: 'Зарегистрировать платёж' },
    'Online (Pasarelas de pago)': { pt: 'Online (Gateways de pagamento)', en: 'Online (Payment gateways)', ru: 'Онлайн (платёжные шлюзы)' },
    Pagado: { pt: 'Pago', en: 'Paid', ru: 'Оплачено' },
    Motivo: { pt: 'Motivo', en: 'Reason', ru: 'Причина' },
    Mover: { pt: 'Mover', en: 'Move', ru: 'Переместить' },
    'Fisico (Local con direccion)': { pt: 'Físico (Local com endereço)', en: 'Physical (Venue with address)', ru: 'Физический (помещение с адресом)' },
    'Ambulante (Vendedores moviles)': { pt: 'Ambulante (Vendedores móveis)', en: 'Mobile (Roaming sellers)', ru: 'Передвижной (мобильные продавцы)' },
    'Casa (operador raíz)': { pt: 'Casa (operador raiz)', en: 'House (root operator)', ru: 'Дом (корневой оператор)' },
    'Nombre *': { pt: 'Nome *', en: 'Name *', ru: 'Имя *' },
    Descripcion: { pt: 'Descrição', en: 'Description', ru: 'Описание' },
    Identificador: { pt: 'Identificador', en: 'Identifier', ru: 'Идентификатор' },
    'Tipo de Juego': { pt: 'Tipo de Jogo', en: 'Game Type', ru: 'Тип игры' },
    Modalidad: { pt: 'Modalidade', en: 'Mode', ru: 'Режим' },
    Moneda: { pt: 'Moeda', en: 'Currency', ru: 'Валюта' },
    Detalle: { pt: 'Detalhe', en: 'Detail', ru: 'Детали' },
    'Forzar: no imprimir': { pt: 'Forçar: não imprimir', en: 'Force: do not print', ru: 'Принудительно: не печатать' },
    'Forzar: sí imprimir': { pt: 'Forçar: sim, imprimir', en: 'Force: do print', ru: 'Принудительно: печатать' },
    'Sistema (Operaciones automaticas)': { pt: 'Sistema (Operações automáticas)', en: 'System (Automatic operations)', ru: 'Система (автоматические операции)' },
    Copiar: { pt: 'Copiar', en: 'Copy', ru: 'Копировать' },
    Hoy: { pt: 'Hoje', en: 'Today', ru: 'Сегодня' },
    Semana: { pt: 'Semana', en: 'Week', ru: 'Неделя' },
    Mes: { pt: 'Mês', en: 'Month', ru: 'Месяц' },
    'Cargando nodos...': { pt: 'Carregando nós...', en: 'Loading nodes...', ru: 'Загрузка узлов...' },
    'Cargando estructura...': { pt: 'Carregando estrutura...', en: 'Loading structure...', ru: 'Загрузка структуры...' },
    'Integrador Juegos': { pt: 'Integrador de Jogos', en: 'Games Integrator', ru: 'Интегратор игр' },
    Cajas: { pt: 'Caixas', en: 'Tills', ru: 'Кассы' },
    Pantallas: { pt: 'Telas', en: 'Screens', ru: 'Экраны' },
    Inactivos: { pt: 'Inativos', en: 'Inactive', ru: 'Неактивные' },
    'Editar contrato': { pt: 'Editar contrato', en: 'Edit contract', ru: 'Изменить контракт' },
    Identidad: { pt: 'Identidade', en: 'Identity', ru: 'Идентичность' },
    Canales: { pt: 'Canais', en: 'Channels', ru: 'Каналы' },
    heredado: { pt: 'herdado', en: 'inherited', ru: 'унаследовано' },
    'sobre GGR': { pt: 'sobre GGR', en: 'on GGR', ru: 'от GGR' },
    'sobre recarga jugada': { pt: 'sobre recarga jogada', en: 'on wagered top-up', ru: 'от сыгранного пополнения' },
    juego: { pt: 'jogo', en: 'game', ru: 'игра' },
    juegos: { pt: 'jogos', en: 'games', ru: 'игры' },
    'Último ingreso': { pt: 'Último acesso', en: 'Last login', ru: 'Последний вход' },
    'Registrar pago': { pt: 'Registrar pagamento', en: 'Register payment', ru: 'Зарегистрировать платёж' },
    'Nuevo Nodo': { pt: 'Novo Nó', en: 'New Node', ru: 'Новый узел' },
    'Heredar del padre': { pt: 'Herdar do pai', en: 'Inherit from parent', ru: 'Наследовать от родителя' },
    de: { pt: 'de', en: 'of', ru: 'из' },
    'sin datos': { pt: 'sem dados', en: 'no data', ru: 'нет данных' },
    'sin config': { pt: 'sem config', en: 'no config', ru: 'нет настроек' },
    'Apuestas a restringir': { pt: 'Apostas a restringir', en: 'Bets to restrict', ru: 'Ставки для ограничения' },
    'Marcar las que NO se pueden vender': { pt: 'Marque as que NÃO podem ser vendidas', en: 'Check the ones that CANNOT be sold', ru: 'Отметьте те, которые НЕЛЬЗЯ продавать' },
    Reactivar: { pt: 'Reativar', en: 'Reactivate', ru: 'Реактивировать' },
    'Reasignar aparato': { pt: 'Reatribuir aparelho', en: 'Reassign device', ru: 'Переназначить устройство' },
    'Obtener link de acceso': { pt: 'Obter link de acesso', en: 'Get access link', ru: 'Получить ссылку доступа' },
    'Error cargando nodos': { pt: 'Erro ao carregar nós', en: 'Error loading nodes', ru: 'Ошибка загрузки узлов' },
    Personalizado: { pt: 'Personalizado', en: 'Custom', ru: 'Настраиваемый' },
    'A favor': { pt: 'A favor', en: 'In favor', ru: 'В пользу' },
    Debe: { pt: 'Deve', en: 'Owes', ru: 'Должен' },
    Saldo: { pt: 'Saldo', en: 'Balance', ru: 'Баланс' },
    'Ver historial': { pt: 'Ver histórico', en: 'View history', ru: 'Посмотреть историю' },
    Premios: { pt: 'Prêmios', en: 'Prizes', ru: 'Призы' },
    Recargas: { pt: 'Recargas', en: 'Top-ups', ru: 'Пополнения' },
    Neto: { pt: 'Líquido', en: 'Net', ru: 'Нетто' },
    Pendiente: { pt: 'Pendente', en: 'Pending', ru: 'В ожидании' },
    'Descripción': { pt: 'Descrição', en: 'Description', ru: 'Описание' },
    'Teléfono': { pt: 'Telefone', en: 'Phone', ru: 'Телефон' },
    'Anomalías': { pt: 'Anomalias', en: 'Anomalies', ru: 'Аномалии' },
    Documento: { pt: 'Documento', en: 'Document', ru: 'Документ' },
    'Guardando...': { pt: 'Salvando...', en: 'Saving...', ru: 'Сохранение...' },
    'Enviar por WhatsApp': { pt: 'Enviar pelo WhatsApp', en: 'Send via WhatsApp', ru: 'Отправить через WhatsApp' },
    opcional: { pt: 'opcional', en: 'optional', ru: 'необязательно' },
    'Todos los nodos': { pt: 'Todos os nós', en: 'All nodes', ru: 'Все узлы' },
    Sorteo: { pt: 'Sorteio', en: 'Draw', ru: 'Розыгрыш' },
    'Error de conexión': { pt: 'Erro de conexão', en: 'Connection error', ru: 'Ошибка соединения' },
    'Selecciona un tipo de juego': { pt: 'Selecione um tipo de jogo', en: 'Select a game type', ru: 'Выберите тип игры' },
    'Selecciona al menos un sorteo': { pt: 'Selecione pelo menos um sorteio', en: 'Select at least one draw', ru: 'Выберите хотя бы один розыгрыш' },
    'Dispositivo autorizado': { pt: 'Dispositivo autorizado', en: 'Device authorized', ru: 'Устройство авторизовано' },
    Pantalla: { pt: 'Tela', en: 'Screen', ru: 'Экран' },
    'Código': { pt: 'Código', en: 'Code', ru: 'Код' },
    'Heredar del Punto de Venta': { pt: 'Herdar do Ponto de Venda', en: 'Inherit from Point of Sale', ru: 'Наследовать от точки продаж' },
    'Personalizar para esta caja': { pt: 'Personalizar para esta caixa', en: 'Customize for this till', ru: 'Настроить для этой кассы' },
    'Modo de entrada': { pt: 'Modo de entrada', en: 'Input mode', ru: 'Режим ввода' },
    'Calculadora (numpad)': { pt: 'Calculadora (numpad)', en: 'Calculator (numpad)', ru: 'Калькулятор (цифровая клавиатура)' },
    'Cargando saldos...': { pt: 'Carregando saldos...', en: 'Loading balances...', ru: 'Загрузка балансов...' },
    'Seleccione un usuario para ver su ficha': { pt: 'Selecione um usuário para ver sua ficha', en: 'Select a user to view their details', ru: 'Выберите пользователя, чтобы открыть его карточку' },
    Acceso: { pt: 'Acesso', en: 'Access', ru: 'Доступ' },
    'Ubicación': { pt: 'Localização', en: 'Location', ru: 'Местоположение' },
    Online: { pt: 'Online', en: 'Online', ru: 'Онлайн' },
};
